module.exports = __webpack_public_path__ + "static/ba_grad_mobile-0dd46e6f988ff61ad9c58293710be867.svg";